import React, { useState, useEffect } from "react";
import { Outlet } from "react-router-dom";
import Sidebar from "./Sidebar";
import Navbar from "./Navbar";

const Layout: React.FC = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState<boolean>(false);
  const [activeTab, setActiveTab] = useState<"B2B" | "B2C">("B2C");

  // Read activeTab from localStorage on mount
  useEffect(() => {
    const storedTab = localStorage.getItem("active_tab") as
      | "B2B"
      | "B2C"
      | null;
    if (storedTab) {
      setActiveTab(storedTab);
    } else {
      setActiveTab("B2C"); // default to B2C
      localStorage.setItem("active_tab", "B2C"); // also store it
    }
  }, []);

  // Function to update activeTab and store in localStorage
  const toggleTab = () => {
    const newTab: "B2B" | "B2C" = activeTab === "B2B" ? "B2C" : "B2B";
    setActiveTab(newTab);
    localStorage.setItem("active_tab", newTab);
  };

  return (
    <div className="flex h-screen bg-[#ffffff] overflow-hidden">
      <Sidebar
        isOpen={isSidebarOpen}
        toggleSidebar={() => setIsSidebarOpen(!isSidebarOpen)}
      />
      <div className="flex-1 flex flex-col overflow-hidden">
        <Navbar activeTab={activeTab} toggleTab={toggleTab} />{" "}
        {/* Pass Props */}
        <div className="flex-1 overflow-auto bg-[#F5F5F4] py-4 custom-scrollbar md:p-5 mt-14">
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default Layout;
